import type { CSSProperties, SVGProps } from 'react'
import classes from './icon.module.css'

export type KeyboardArrowRightProps = SVGProps<SVGSVGElement> & {
  className?: string
  style?: CSSProperties
}
export function KeyboardArrowRight(props: KeyboardArrowRightProps) {
  const { className, style, ...rest } = props

  const cls = `${classes.root} ${className || ''}`
  return (
    <svg
      aria-hidden="true"
      className={cls}
      focusable="false"
      viewBox="0 0 24 24"
      {...rest}
      data-testid="KeyboardArrowRightIcon"
      style={style}
    >
      <path d="M8.59 16.59 13.17 12 8.59 7.41 10 6l6 6-6 6z" />
    </svg>
  )
}
